import { dateUIToBackend } from 'modules/core/lib/dates'

export const formatDueDate = (dueDate: string | undefined): string => {
  const uiDateRegex = /^\d{2}\/\d{2}\/\d{4}$/
  return dueDate && uiDateRegex.test(dueDate) ? dateUIToBackend(dueDate) : dueDate ?? ''
}
